import RicevutaDettaglio from "./RicevutaDettaglio";

export class Ricevuta {
    id?: number;
    data?: string;
    imponibile?: number;
    imposta?: number;
    ristoranteId?: string;
    dettaglioList: RicevutaDettaglio[];

    constructor() {
        this.dettaglioList = [];
    }

    static fromJSON(json: any): Ricevuta {
        let result = new Ricevuta();
        result.id = json.id;
        result.data = json.data;
        result.imponibile = Number(json.imponibile);
        result.imposta = Number(json.imposta);
        result.ristoranteId = json.ristoranteId;
        if (json.dettaglioList) {
            result.dettaglioList = json.dettaglioList.map((item: any) => RicevutaDettaglio.fromJSON(item));
        }
        return result;
    }
}

export default Ricevuta;
